import { render, staticRenderFns } from "./SelectCommodityByCodeModal.vue?vue&type=template&id=4c5baa88&scoped=true"
import script from "./SelectCommodityByCodeModal.vue?vue&type=script&lang=js"
export * from "./SelectCommodityByCodeModal.vue?vue&type=script&lang=js"
import style0 from "./SelectCommodityByCodeModal.vue?vue&type=style&index=0&id=4c5baa88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5baa88",
  null
  
)

export default component.exports